/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Country } from '../../models/country';

export interface GetCountry$Params {
  countryCode: string;
}

export function getCountry(http: HttpClient, rootUrl: string, params: GetCountry$Params, context?: HttpContext): Observable<StrictHttpResponse<Country>> {
  const rb = new RequestBuilder(rootUrl, getCountry.PATH, 'get');
  if (params) {
    rb.path('countryCode', params.countryCode, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Country>;
    })
  );
}

getCountry.PATH = '/geography/countries/{countryCode}';
